export default [{
	titulo: 'Classificados',
	icone: 'menu-icon fa fa-caret-right',
	url: '/sistema/classificados',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]